import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { userReducer } from 'features/auth';
import 'features/notification-config/services/adminRoles.api';
import 'features/notification-config/services/businessRules.api';
import { selectedProjectReducer } from 'features/projects';
import 'features/projects/services/alerts.api';
import 'features/projects/services/projects.api';
import 'features/webhooks/services/webhooks.api';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import baseApi from 'shared/api/baseApi';

const rootReducer = combineReducers({
  user: userReducer,
  selectedProject: selectedProjectReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

const persistedReducer = persistReducer(
  { key: 'root-backoffice', storage, whitelist: ['user', 'selectedProject'] },
  rootReducer
);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          'api/executeMutation/fulfilled',
          'api/executeMutation/rejected',
        ],
        ignoredPaths: ['api.mutations'],
      },
    }).concat(baseApi.middleware),
});

setupListeners(store.dispatch);

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
